import { StandardInput } from "@/components/ui/forms/standardInput"
import { WarningHexagonalIcon } from "@images/svgIcons/warningIcon"
import { type BoxFormPageProps } from "@modules/box/components/boxCreationForm/boxFormFirstPage"
import { BoxFormTemplatePage } from "@modules/box/components/boxCreationForm/boxFormTemplatePage"
import { word } from "@modules/core/utils/i18n"
import { HUCardAlert } from "@modules/ui/components/huCardAlert"

export const BoxFormLegalDocumentsPage = ({
  handleSubmit,
  onPrevious,
  formik,
  getFormErrorMessage,
  disabled,
}: BoxFormPageProps) => {
  return (
    <BoxFormTemplatePage
      onPrevious={onPrevious}
      handleSubmit={handleSubmit}
      disabled={disabled}
      header={{
        title: word("box.creation.page.legal.title"),
        description: word("box.creation.page.legal.description"),
        children: (
          <HUCardAlert
            title={word("box.creation.page.legal.alert")}
            icon={<WarningHexagonalIcon color="currentColor" className="text-white" />}
            className="gap-8 rounded-2xl px-8 py-4"
          />
        ),
      }}
    >
      <StandardInput
        isRequiredInput
        label={word("box.creation.page.legal.label")}
        inputProps={{
          placeholder: word("box.creation.page.legal.placeholder"),
        }}
        getFieldProps={formik.getFieldProps}
        setFieldValue={formik.setFieldValue}
        name="siren"
        error={getFormErrorMessage("siren")}
      />
    </BoxFormTemplatePage>
  )
}
